import { Button, Container, Divider, Stack, Text } from '@chakra-ui/react';
import { useError, useStaleBundleToast } from '@pelicargo/ui';
import { AUTH_VERSION_SUPABASE } from '@pelicargo/utils';
import { useForm } from 'react-hook-form';
import { useNavigate } from 'react-router-dom';

import { Page } from '../components/Page';
import { PelicargoLogo } from '../components/PelicargoLogo';
import { SimpleForm } from '../components/SimpleForm';
import { SimpleInput } from '../components/SimpleInput';
import { ENV } from '../config/env';
import { supabase } from '../config/supabase';

type FormValues = {
  email: string;
  password: string;
};

export const Login = () => {
  const navigate = useNavigate();
  const { handleError } = useError();

  useStaleBundleToast({ apiBaseUrl: ENV.API_BASE_URL, expectedVersion: AUTH_VERSION_SUPABASE });

  const methods = useForm({
    defaultValues: {
      email: '',
      password: '',
    },
  });

  const handleSubmit = async (values: FormValues) => {
    try {
      const { error } = await supabase.auth.signInWithPassword(values);
      if (error) {
        throw new Error(error?.message);
      }
      window.location.reload();

      navigate('/requests');
    } catch (error) {
      handleError(error);
    }
  };

  const handleGoogleSignIn = async () => {
    const { error } = await supabase.auth.signInWithOAuth({
      provider: 'google',
      options: {
        queryParams: {
          access_type: 'offline',
          prompt: 'consent',
        },
        redirectTo: window.location.origin,
      },
    });

    if (error) handleError(error);
  };

  const onSubmit = methods.handleSubmit(handleSubmit);

  return (
    <Page title="Login" display="flex" justifyContent="center" alignItems="center">
      <Container maxW="sm">
        <Stack spacing="8" align="center" w="full">
          <PelicargoLogo maxW="80" />
          <SimpleForm submitOnBlur={false} {...methods}>
            <Stack w="full" spacing="8" align="center">
              <Button size="md" w="full" onClick={handleGoogleSignIn}>
                Login with Google
              </Button>

              <Divider maxW="80%" />

              <Stack w="full" spacing="4" align="center">
                <SimpleInput label="Email" name="email" inputAttrs={{ autoComplete: 'email' }} />
                <SimpleInput
                  label="Password"
                  name="password"
                  inputAttrs={{ autoComplete: 'password', type: 'password' }}
                />
                <Button colorScheme="brand" size="md" w="full" onClick={onSubmit}>
                  Login
                </Button>
              </Stack>
            </Stack>
          </SimpleForm>
        </Stack>
      </Container>
      <Text position="absolute" bottom={3} textAlign="center" fontSize="xs" color="gray.400">
        Built at {import.meta.env.VITE_BUILD_TIME}
      </Text>
    </Page>
  );
};
